import * as React from 'react'
import styled from 'styled-components'
import { Icon } from 'antd'

const SelectedIcon = styled(Icon)`
  &&& {
    display: none;
  }

  @media (min-width: 48rem) {
    display: block;
    background: #80d135;
    border-radius: 50%;
    padding: 0.25rem 0.2rem 0.2rem;
    color: white;

    position: absolute;
    top: 1rem;
    right: 1rem;

    font-size: 0.75rem;
    font-weight: 900;
  }
`

export default () => <SelectedIcon type="check" />



// WEBPACK FOOTER //
// ./src/components/SelectedIcon/SelectedIcon.tsx